import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Translation } from '../../models/translation';

export const TRANSLATIONS_ACTIONS = {
  SET_TRANSLATIONS: 'SET_TRANSLATIONS',
  UPDATE_TRANSLATION: 'UPDATE_TRANSLATION'
};

@Injectable()
export class TranslationsActions {

  constructor(private store: Store<Translation[]>) { }

  setTranslations(translations: Translation[]) {
    this.store.dispatch({ type: TRANSLATIONS_ACTIONS.SET_TRANSLATIONS, payload: translations });
  }

  updateTranslationPicture(translation: Translation) {
    this.store.dispatch({ type: TRANSLATIONS_ACTIONS.UPDATE_TRANSLATION, payload: translation });
  }
}


// WEBPACK FOOTER //
// ./src/app/store/actions/translations.actions.ts